import {Injectable} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {Store} from '@ngrx/store';
import {Apollo} from 'apollo-angular';
import {map, switchMap} from 'rxjs';
import {NotificationService} from 'src/app/services/notification.service';
import {ResponseCodeService} from 'src/app/services/response-code.service';
import {AppState} from 'src/app/store/reducers';
import * as fromActions from "./institution-admin.actions";
import * as fromGraphql from "./institution-admin.graphql";
import {ACTIVATE_DEACTIVATE_USER_MUTATION} from "../../../instution-settings/instution-user/instution-user.graphql";
import {getSystemAdministrators} from "../../user-management/user-management.actions";
import {UserTypeInum} from "./institution-admin.model";


@Injectable()
export class InstitutionAdminEffects {
  createInstitutionAdminstrators = createEffect(() => this.actions$.pipe(
    ofType(fromActions.createInstitutionAdminstrators),
    switchMap((action) => {
      return this.apollo.mutate({
        mutation: fromGraphql.CREATE_INSTITUTION_ADMINISTRATOR,
        variables: {
          input: action?.input
        }
      }).pipe(
        this.notificationService.catchError('Problem occurred while saving record'),
        map(({ data }: any) => {

          if (data) {
            const result: any = Object.values(data)[0];
            if (result?.response?.code == '9000') {
              this.store.dispatch(
                fromActions.upsertInstitutionAdmin({ institutionAdmin: {
                  id: result?.data?.id,
                    profile: result?.data?.adminProfile,
                  } })
              );
              this.notificationService.successMessage('Created Successfully');
            } else {
              this.notificationService.errorMessage(result?.response?.message + ' code:' + result?.response?.code);
            }
          }
        })
      );
    })
  ), { dispatch: false });

  updateInstitutionAdminstrators = createEffect(() => this.actions$.pipe(
    ofType(fromActions.updateInstitutionAdminstrators),
    switchMap((action) => {
      return this.apollo.mutate({
        mutation: fromGraphql.UPDATE_INSTITUTION_ADMINISTRATOR,
        variables: {
          input: action?.input
        }
      }).pipe(
        this.notificationService.catchError('Problem occurred while updating record'),
        map(({ data }: any) => {
          if (data) {
            const result: any = Object.values(data)[0];
            if (result?.response?.code == '9000') {
              this.store.dispatch(
                fromActions.upsertInstitutionAdmin({ institutionAdmin: {
                    id: result?.data?.id,
                    profile: result?.data?.adminProfile,
                  } })
              );
              this.notificationService.successMessage('Updated Successfully');
            }
            else {
              this.notificationService.errorMessage(result?.response?.message + ' code:' + result?.response?.code);
            }
          }
        })
      );
    })
  ), { dispatch: false });

  deleteInstitutionAdminstrators = createEffect(() => this.actions$.pipe(
    ofType(fromActions.deleteInstitutionAdminstrators),
    switchMap((action) => {
      return this.apollo.mutate({
        mutation: fromGraphql.DELETE_INSTITUTION_ADMINISTRATOR,
        variables: {
          profileUniqueId: action?.profileUniqueId
        }
      }).pipe(
        this.notificationService.catchError('Problem occurred while deleting record'),
        map(({ data }: any) => {
          if (data) {
            const result: any = Object.values(data)[0];
            if (result?.response?.code == '9000') {
              this.store.dispatch(fromActions.deleteInstitutionAdmin({ id: action.id }));
              this.notificationService.successMessage('Deleted Successfully');
            } else {
              this.notificationService.errorMessage(result?.response?.message + ' code:' + result?.response?.code);
            }
          }
        })
      );
    })
  ), { dispatch: false });

  activateDeactivateAdmins$ = createEffect(() => this.actions$.pipe(
    ofType(fromActions.activateDeactivateInstitutionAdministrator),
    switchMap((action) => {
      return this.apollo.mutate({
        mutation: ACTIVATE_DEACTIVATE_USER_MUTATION,
        variables: {
          profileUniqueId: action?.profileUniqueId
        }
      }).pipe(
        this.notificationService.catchError('Problem occurred'),
        map(({data}: any) => {
          if (data) {
            const result: any = Object.values(data)[0];
            if (result?.response?.code == '9000') {

              if (action?.institutionUniqueId) {
                this.store.dispatch(fromActions.getInstitutionUsers({
                  filtering: {
                    institutionUniqueId: action?.institutionUniqueId,
                    profileType: action?.profileType
                  }
                }))
              } else {
                this.store.dispatch(getSystemAdministrators({
                  filtering: {profileType: UserTypeInum.POPSM}
                }))
              }

              this.notificationService.successMessage("Operation Successful")
            } else {
              this.notificationService.errorMessage(result?.response?.message + ' code:' + result?.response?.code);
            }
          }
        })
      )
    })
  ), {dispatch: false})

  getInstitutionUsers = createEffect(() => this.actions$.pipe(
    ofType(fromActions.getInstitutionUsers),
    switchMap((action) => {
      return this.apollo.query({
        query: fromGraphql.GET_ALL_INSTITUTIONS,
        fetchPolicy: 'network-only',
        variables:{
          filtering: action?.filtering
        }
      }).pipe(
        this.notificationService.catchError('Problem occurred while fetching institutions'),
        map(({ data }: any ) => {
          if (data) {
            const result: any = Object.values(data)[0]
            result?.response?.status ? this.store.dispatch(fromActions.loadInstitutionAdmins({ institutionAdmins: result?.data })) : []
          }
        })
      );
    })
  ), { dispatch: false });

  constructor(
    private actions$: Actions,
    private apollo: Apollo,
    private store: Store<AppState>,
    private notificationService: NotificationService,
    private responseCodesService: ResponseCodeService
  ) {}
}
